import request from '@/axios'

/**
 * @Description: 获取解决方案导航
 */
export function selectSolutions(){
  return request({
    method:'post',
    url:'/api/Solution/selectSolutions',
    params: {}
  })
}

/**
 * @Description: 查询【根据id查看内容】
 */
export function selectSolutionById(data){
  return request({
    method:'post',
    url:'/api/Solution/selectSolutionById',
    params: data
  })
}


